export function getDiscountInfo(fee: number, percent?: number) {
  if (!percent) {
    return {
      discountedPrice: fee,
      savings: 0,
      percentage: 0,
    };
  }

  const discountedPrice = +(fee * (1 - percent / 100)).toFixed(2);
  const savings = +(fee - discountedPrice).toFixed(2);

  return {
    discountedPrice,
    savings,
    percentage: percent,
  };
}
